import { MdAppShortcut, MdOutlineMessage, MdWhatsapp } from "react-icons/md"
import { Button, ButtonLoader } from "../../components/Button"
import { CheckBox, TextArea } from "../../components/Form"
import { ListViewMessageSend, ListViewTemplates } from "../../components/ListView"
import {
  ModalBody,
  ModalDouble,
  ModalFooter,
  ModalHeader,
  ModalPanel,
} from "../../components/Modal"
import ModalAlert from "../../components/ModalAlert"
import { Grid } from "../../components/Table"
import { MessageTemplates } from "../../core/mocks/templates/messages"
import "./styles.scss"
import { ImBlocked } from "react-icons/im"
import { isMobile } from "react-device-detect"

const columns = [
  {
    id: "user",
    field: "name",
    label: "Produtor",
    width: "300px",
    cellRenderer: ({ data }) => (
      <div className="rgt-cell-inner action">
        <div className="mnj-table-user-component">
          <div className="mnj-table-user-component-info">
            <span className="mnj-table-user-component-info-name">{data?.name}</span>
            <span className="mnj-table-user-component-info-email">{data?.email}</span>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: "project",
    field: "project",
    label: "Projeto",
    width: "250px",
  },
]

const columnsResponse = [
  {
    id: "id",
    field: "name",
    label: "Produtor",
    width: "250px",
    cellRenderer: ({ data }) => (
      <div className="rgt-cell-inner action">
        <div className="mnj-table-user-component">
          <div className="mnj-table-user-component-info">
            <span className="mnj-table-user-component-info-name">{data?.name}</span>
            <span className="mnj-table-user-component-info-email">{data?.email}</span>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: "shipping.id",
    field: "shipping.title",
    label: "Meio",
    width: "130px",
    cellRenderer: ({ data }) => (
      <div className="rgt-cell-inner action shipping">
        {data?.shipping?.title === "whatsapp" ? (
          <MdWhatsapp />
        ) : data?.shipping?.title === "Sem Whatsapp" ? (
          <ImBlocked title="Sem Whatsapp" />
        ) : (
          <MdAppShortcut title="Manejechat" />
        )}
        <span>{data?.shipping?.title}</span>
      </div>
    ),
  },
  {
    id: "project",
    field: "project",
    label: "Projeto",
    width: "250px",
  },
]

const ModalMessageOptions = ({
  selectedUsers,
  sendMessage,
  setText,
  text,
  saving,
  sessionWhatsApp,
  startWhatsAppSession,
  onCheckedChange,
  checked,
  showTemplates,
  handleSelectedTemplate,
  selectedTemplate,
  handleOpenTemplateList,
  handleCloseTemplateList,
  toggleOriginalTemplateSending,
  startSession,
  setStartSession,
  handleCreateTemplate,
  templates,
  handleDelete
}) => {
  return isMobile ? (
    <div className="modal-message-mobile">
      <div className="list-users-message-mobile">
        {selectedUsers.map((user) => (
          <div className="before-dot">
            <div className="mnj-table-user-component-info">
              <span className="mnj-table-user-component-info-name">{user?.name}</span>
              <span className="mnj-table-user-component-info-email">{user?.email}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="secondary message-button-template">
        <div className="template-button-container">
          <Button
            handleClick={() =>
              showTemplates ? handleCloseTemplateList() : handleOpenTemplateList()
            }
            variant="ghost"
            label={showTemplates ? "Escrever Mensagem" : "Ver Templates"}
          />
        </div>
        {showTemplates ? (
          <div className="list-templates-message">
            <ListViewTemplates
              data={templates}
              handleClick={handleSelectedTemplate}
              selectedTemplate={selectedTemplate}
              handleDelete={handleDelete}
            />
          </div>
        ) : (
          <TextArea
            onChange={(e) => setText(e.target.value)}
            resize={"none"}
            value={text}
            placeholder="Escreva sua mensagem aqui..."
            height="95%"
            isWhite
          />
        )}
        <ModalFooter className="p-0">
          {sessionWhatsApp?.hasUsersToStart && (
            <ButtonLoader
              label={!sessionWhatsApp.completed ? "Iniciar Integração" : "Integração Ativa"}
              handleClick={() =>
                ModalAlert.warn({
                  title: "Deseja iniciar uma conversa no whatsapp?",
                  text: "Isso irá ativar a integração entre os produtores que possuem whataspp. Caso a integração esteja ativa com outro(a) técnico(a), você será o(a) novo(a) responsável pela conversa.",
                  confirmLabel: "Iniciar",
                  onConfirm: () => startWhatsAppSession(),
                })
              }
              color="orange"
              loading={sessionWhatsApp && sessionWhatsApp.started}
              isDisabled={sessionWhatsApp && sessionWhatsApp.completed}
              messageProcess="Iniciando Integração"
            />
          )}
          {!showTemplates && (
            <CheckBox label="Enviar texto original" onChange={toggleOriginalTemplateSending} />
          )}
          <ButtonLoader
            label="Enviar"
            // handleClick={sendMessage}
            handleClick={() =>
              selectedTemplate
                ? sendMessage()
                : ModalAlert.warn({
                    title: "Deseja confirmar o envio da mensagem?",
                    // text: "Certifique-se de ter iniciado a integração com o whatsapp.",
                    confirmLabel: "Enviar",
                    onConfirm: () => sendMessage(),
                  })
            }
            isDisabled={sessionWhatsApp && sessionWhatsApp.started}
            color="orange"
            loading={saving}
            messageProcess="Enviando Mensagem"
          />
        </ModalFooter>
      </div>
    </div>
  ) : (
    <>
      <ModalDouble title="Produtores Selecionados" position={"left"} noPadding>
        <Grid
          isPaginated={false}
          columns={columns}
          rows={selectedUsers}
          height={500}
          // onSelectedRowsChange={changeOptions}
        />
      </ModalDouble>
      <ModalDouble position={"right"} className="secondary message-button-template">
        <div className="row-button-container">
          <div className="add-template-button-container">
            {showTemplates && (
              <Button
                handleClick={handleCreateTemplate}
                variant="ghost"
                color={"orange"}
                label={"Cadastrar template"}
              />
            )}
          </div>
          <div className="template-button-container">
            <Button
              handleClick={() =>
                showTemplates ? handleCloseTemplateList() : handleOpenTemplateList()
              }
              variant="ghost"
              label={showTemplates ? "Escrever Mensagem" : "Ver Templates"}
            />
          </div>
        </div>
        {showTemplates ? (
          <div className="list-templates-message">
            <ListViewTemplates
              data={templates}
              handleClick={handleSelectedTemplate}
              selectedTemplate={selectedTemplate}
              handleDelete={handleDelete}
            />
          </div>
        ) : (
          <TextArea
            onChange={(e) => setText(e.target.value)}
            resize={"none"}
            value={text}
            placeholder="Escreva sua mensagem aqui..."
            height="95%"
            isWhite
          />
        )}
        <ModalFooter className="p-0">
          {/* <CheckBox
            label="Iniciar sessão do Whatsapp"
            checked={startSession}
            onChange={e => setStartSession(e.target.checked)}
          /> */}
          {sessionWhatsApp?.hasUsersToStart && (
            <ButtonLoader
              label={!sessionWhatsApp.completed ? "Iniciar Integração" : "Integração Ativa"}
              handleClick={() =>
                ModalAlert.warn({
                  title: "Deseja iniciar uma conversa no whatsapp?",
                  text: "Isso irá ativar a integração entre os produtores que possuem whataspp. Caso a integração esteja ativa com outro(a) técnico(a), você será o(a) novo(a) responsável pela conversa.",
                  confirmLabel: "Iniciar",
                  onConfirm: () => startWhatsAppSession(),
                })
              }
              color="orange"
              loading={sessionWhatsApp && sessionWhatsApp.started}
              isDisabled={sessionWhatsApp && sessionWhatsApp.completed}
              messageProcess="Iniciando Integração"
            />
          )}
          {!showTemplates && (
            <CheckBox label="Enviar texto original" onChange={toggleOriginalTemplateSending} />
          )}
          <ButtonLoader
            label="Enviar"
            // handleClick={sendMessage}
            handleClick={() =>
              selectedTemplate
                ? sendMessage()
                : ModalAlert.warn({
                    title: "Deseja confirmar o envio da mensagem?",
                    // text: "Certifique-se de ter iniciado a integração com o whatsapp.",
                    confirmLabel: "Enviar",
                    onConfirm: () => sendMessage(),
                  })
            }
            isDisabled={sessionWhatsApp && sessionWhatsApp.started}
            color="orange"
            loading={saving}
            messageProcess="Enviando Mensagem"
          />
        </ModalFooter>
      </ModalDouble>
    </>
  )
}

const ModalMessageFeedBack = ({
  usersFailed,
  usersReceived,
  countMessageFailed,
  countMessageSend,
  onCheckedChange,
  checked,
}) => {
  return (
    <>
      <ModalDouble
        title={`Mensagens Enviadas ${countMessageSend ? `(${countMessageSend})` : ""}`}
        position={"left"}
        noPadding>
        {countMessageSend !== 0 ? (
          <>
            <Grid
              isPaginated={false}
              columns={columns}
              rows={
                Array.isArray(usersReceived) &&
                usersReceived.map((item) => ({
                  ...item,
                  shipping: {
                    id: Math.random(),
                    title:
                      Array.isArray(item?.hasSession) && item.hasSession.length
                        ? "whatsapp"
                        : "manejechat",
                  },
                }))
              }
              height={500}
              // onSelectedRowsChange={changeOptions}
            />
          </>
        ) : (
          <div className="no-message-failed">Nenhuma mensagem enviada</div>
        )}
      </ModalDouble>
      <ModalDouble
        title={`Mensagens Que Falharam ${countMessageFailed ? `(${countMessageFailed})` : ""}`}
        position={"right"}
        className="p-0 divison">
        {countMessageFailed !== 0 ? (
          <>
            <Grid
              isPaginated={false}
              columns={columns}
              rows={
                Array.isArray(usersFailed) &&
                usersFailed.map((item) => ({
                  ...item,
                  shipping: {
                    id: Math.random(),
                    title:
                      Array.isArray(item?.hasSession) && item.hasSession.length
                        ? "whatsapp"
                        : "manejechat",
                  },
                }))
              }
              height={500}
              onSelectedRowsChange={(e) =>
                onCheckedChange(e, Array.isArray(usersFailed) && usersFailed)
              }
            />
          </>
        ) : (
          <div className="no-message-failed">Nenhuma mensagem falhou</div>
        )}
      </ModalDouble>
    </>
  )
}

const MessageScreen = ({
  open,
  selectedUsers,
  handleCloseModal,
  sendMessage,
  setText,
  text,
  saving,
  sessionWhatsApp,
  startWhatsAppSession,
  countMessageFailed,
  countMessageSend,
  isResponseModalOpen,
  usersFailed,
  usersReceived,
  onCheckedChange,
  checked,
  setShowTemplates,
  showTemplates,
  handleSelectedTemplate,
  selectedTemplate,
  handleCloseTemplateList,
  handleOpenTemplateList,
  toggleOriginalTemplateSending,
  startSession,
  setStartSession,
  handleCreateTemplate,
  templates,
  handleDelete
}) => {
  return (
    <>
      {open && (
        <ModalPanel modalIsOpen={open}>
          <ModalHeader closeModal={handleCloseModal} title="Enviar Mensagem" />
          <ModalBody className="modal-message message-mobile">
            {!isResponseModalOpen ? (
              <ModalMessageOptions
                {...{
                  selectedUsers,
                  sendMessage,
                  setText,
                  text,
                  saving,
                  sessionWhatsApp,
                  startWhatsAppSession,
                  onCheckedChange,
                  checked,
                  setShowTemplates,
                  showTemplates,
                  handleSelectedTemplate,
                  selectedTemplate,
                  handleCloseTemplateList,
                  handleOpenTemplateList,
                  toggleOriginalTemplateSending,
                  startSession,
                  setStartSession,
                  handleCreateTemplate,
                  templates,
                  handleDelete
                }}
              />
            ) : (
              <ModalMessageFeedBack
                {...{
                  usersFailed,
                  usersReceived,
                  sendMessage,
                  setText,
                  saving,
                  countMessageSend,
                  countMessageFailed,
                  onCheckedChange,
                  checked,
                }}
              />
            )}
          </ModalBody>
        </ModalPanel>
      )}
    </>
  )
}

export default MessageScreen
